import * as React from "react";
import { LabelAndPopover } from '../formcontrols/components/label-and-popover';

export interface TitleHeadingTwoProps {
  formFieldDefinition: any; 
}

export const TitleHeadingTwo = (props: TitleHeadingTwoProps) => {
  return <>
    <h3 className="form-control-title-heading-two">{props.formFieldDefinition.label}<LabelAndPopover 
        fieldId="" 
        label=""
        containerClassName="label-and-popover--inside-heading"
        explanation={props.formFieldDefinition.explanation}
        hasPopover={props.formFieldDefinition.hasPopover}                    
    ></LabelAndPopover></h3>
    {props.formFieldDefinition.description && <p className="form-control-title-heading-two__description">{props.formFieldDefinition.description}</p>}
  </ >;

};